import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import ArtistUI from "./artist-ui/Artist";
import VerifyPhoneNumberArtist from "./artist-ui/VerifyPhoneNumberArtist"
import LoginArtist from "./artist-ui/LoginArtist";
import "./custom.css";
import LoginCallback from "./artist-ui/LoginCallback";
import NotAcceptable from './based/406Page';
import AccessDenied from "./artist-ui/AccessDenied";

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Switch>
                <Route exact path="/" component={ArtistUI} />
                <Route exact path="/verify" component={VerifyPhoneNumberArtist} />
                <Route exact path="/access-denied" component={AccessDenied} />
                <Route exact path="/artist/:tab?" component={ArtistUI} />
                <Route exact path="/login" component={LoginArtist} />
                <Route exact path="/login-social-callback" component={LoginCallback} />
                <Route exact path="/not-acceptable" component={NotAcceptable} />
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js